import {useState,useEffect} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {Titlebar,Searchbox} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
const Ingredient = () =>{

    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    

    useEffect(()=>{
      getallingredient();
    },[]); 

  const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id" },
    { headerName: "Ingredient Name",field: "ingredient_name" },
    { headerName: "SKU Code",field: "sku_code",cellRenderer: (params) => {
        return (
            <Tag severity="success" value={params.getValue()} rounded></Tag>
         
        );
      } },
    { headerName: "Supplier",field: "supplier" },
    { headerName: "Cost Per unit",field: "units_used_per_product" },
    { headerName: "Units Used \t per Product",
       
        field: "name" },
    { headerName: "Total Stock Used Across Products",field: "total_stock_used_across_products" },
    { headerName: "Stock Level",field: "stock_level" },
    { headerName: "Restock Alert",field: "stock_alert" },
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             <button class="btn  btn-sm btn-white custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button>
             {/* <button class="btn btn-danger btn-sm btn-white btn-border-none"><i class="icon icon-trash txt-error icon-style"></i></button>  */}
        </>
       
      );
    } }
  ]);

  const editredirect = (id,productData) =>{
    // navigate(`/editproduct/${id}`);
    navigate(`/editingredient/${id}`, { state: { product: productData } });
  }


  const getallingredient  = ()=> {
        // setUserloaded(false);
        productservices.getallingredient().then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
            }else{
              setResults([]);
                // setUsers([]);
                // setUserloaded(true);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addingredient');
  }

  return(
       <>
          <Bredcrum title={'Product'} divider={false}/>
          <div class="row">
              <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => addproductnavigate()}>Add New Free-Issued Ingredients</button> 
                      <Searchbox/>
                  </div> 
              </div> 
             
              
              <Titlebar text={'Margin Matrix'}/>
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Ingredient;